import React from 'react'
import Radium from 'radium'
import Spinner from 'react-spinkit'
import { ColorPalette } from '../../../config/colors'

interface IButtonMainProps {
  children: React.ReactNode
  loading?: boolean
  disabled?: boolean
  style?: React.CSSProperties | undefined
  onClick: (e: React.MouseEvent) => void
}

const buttonMain: React.FC<IButtonMainProps> = (props: IButtonMainProps) => {
  let buttonContents = props.children
  if (props.loading) {
    buttonContents = (
      <Spinner style={{ transform: 'scale(0.6)' }} fadeIn="quarter" name="three-bounce" color="rgba(245,245,245,1)" />
    )
  }

  return (
    <button style={{ ...styles.buttonContainer, ...props.style }} onClick={props.onClick} disabled={props.disabled}>
      {buttonContents}
    </button>
  )
}

const styles = {
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 35,
    borderRadius: 30,
    backgroundColor: ColorPalette.WARNING_RED,
    // backgroundImage: `linear-gradient(to bottom, ${ColorPalette.PRIMARY_BLUE}, ${ColorPalette.SECONDARY_BLUE})`,
    fontSize: '0.9rem',
    fontFamily: 'roboto',
    color: 'rgba(250, 250, 250, 1)',
    border: 'none',
    cursor: 'pointer',
    outline: 0,
    boxShadow: '0px 2px 6px rgba(0, 0, 30, 0.3)',
    ':hover': {
      filter: 'brightness(85%)',
    },
    ':active': {
      filter: 'brightness(50%)',
    },
  },
}

export default Radium(buttonMain)
